module.exports = __webpack_public_path__ + "static/icons/icon-car-hire-8fafaee88f6c61a0e98e9760d41d90dc.svg";